import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class TextDistrictInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'District',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = params.addressInformation.district
  }
}
